import script from "./acceptCampaignModel.vue?vue&type=script&setup=true&lang=js"
export * from "./acceptCampaignModel.vue?vue&type=script&setup=true&lang=js"

import "./acceptCampaignModel.vue?vue&type=style&index=0&id=167e4020&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167e4020"]])

export default __exports__